/* ================= Utility functions ================= */
function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
function nearestAngle(cur,target){
  var T=Math.PI*2, d=(target-cur)%T;
  if(d>Math.PI)d-=T; if(d<-Math.PI)d+=T;
  return cur+d;
}
function rr(x,a,b,w,h,r){ // canvas rounded-rectangle path
  x.beginPath();
  x.moveTo(a+r,b);
  x.arcTo(a+w,b,a+w,b+h,r);
  x.arcTo(a+w,b+h,a,b+h,r);
  x.arcTo(a,b+h,a,b,r);
  x.arcTo(a,b,a+w,b,r);
  x.closePath();
}
function roundedRect(w,h,r){ // three.js rounded-rectangle Shape
  var s=new THREE.Shape(), x0=-w/2, y0=-h/2;
  s.moveTo(x0+r,y0);
  s.lineTo(x0+w-r,y0);
  s.quadraticCurveTo(x0+w,y0,x0+w,y0+r);
  s.lineTo(x0+w,y0+h-r);
  s.quadraticCurveTo(x0+w,y0+h,x0+w-r,y0+h);
  s.lineTo(x0+r,y0+h);
  s.quadraticCurveTo(x0,y0+h,x0,y0+h-r);
  s.lineTo(x0,y0+r);
  s.quadraticCurveTo(x0,y0,x0+r,y0);
  return s;
}
function pillMesh(w,h,depth,mat){ // flat capsule for rear slots and similar details
  var g=new THREE.ExtrudeGeometry(roundedRect(w,h,h*0.48),{depth:depth,bevelEnabled:false,curveSegments:16});
  g.translate(0,0,-depth/2);
  return new THREE.Mesh(g,mat);
}
function capsule(r,len,mat){ // side orange button capsule
  var g=new THREE.Group();
  var cy=new THREE.Mesh(new THREE.CylinderGeometry(r,r,len,24),mat);
  var s1=new THREE.Mesh(new THREE.SphereGeometry(r,20,16),mat); s1.position.y=len/2;
  var s2=new THREE.Mesh(new THREE.SphereGeometry(r,20,16),mat); s2.position.y=-len/2;
  cy.castShadow=s1.castShadow=s2.castShadow=true;
  g.add(cy,s1,s2);
  return g;
}
